export const COMPANY_NAME = "Play Things";
export const COMPANY_SHORT = "Play Things";
export const COMPANY_INITIALS = "PT";
export const COMPANY_ADDRESS_FULL = "6403 Primrose Ave, Los Angeles, CA 90068-2857";
export const COMPANY_LOCATION = "Los Angeles, CA";
export const COMPANY_REGION = "Los Angeles County";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=6403%20Primrose%20Ave%2C%20Los%20Angeles%2C%20CA%2090068-2857";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile", "value": "Public directory" },
  { "label": "Area", "value": "Los Angeles County" },
  { "label": "Location", "value": "Los Angeles, CA" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Play Things" },
  { "label": "City / State", "value": "Los Angeles, CA" },
  { "label": "Address", "value": "6403 Primrose Ave, Los Angeles, CA 90068-2857" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Directory profile", "body": "A concise public overview of Play Things." },
  { "icon": "✦", "title": "Local presence", "body": "Located in Los Angeles, California." },
  { "icon": "✿", "title": "Public information", "body": "Core details are presented clearly and simply." },
  { "icon": "❍", "title": "Visit details", "body": "Use the map link for directions to the listed address." },
];
